import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DropdownButton } from 'react-bootstrap';

class Dropdown extends Component {
  constructor(props) {
    super(props);

    this.defaultTitle = props.defaultTitle;
    this.state = { title: this.defaultTitle };

    this.handleSelect = this.handleSelect.bind(this);
  }

  handleSelect(filterVal, e) {
    this.props.changeFilter(this.props.filter(filterVal));
    this.setState({
      title: (e.target.text !== '-') ? e.target.text : this.defaultTitle
    });
  }

  render() {
    return (
      <DropdownButton bsStyle="primary" title={this.state.title} id={this.props.id} onSelect={this.handleSelect}>
        {this.props.children}
      </DropdownButton>
    );
  }
}

Dropdown.propTypes = {
  defaultTitle: PropTypes.string.isRequired,
  filter: PropTypes.func.isRequired,
  changeFilter: PropTypes.func.isRequired,
  children: PropTypes.array.isRequired,
  id: PropTypes.string.isRequired
};

export default Dropdown;



// WEBPACK FOOTER //
// ./src/components/eventFilter/Dropdown.jsx